import __var_0__ from '@stdlib/assert/is-positive-number';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //
var isPositive = __var_0__.isPrimitive;


// MAIN //

/**
* Validates parameters.
*
* @private
* @param {PositiveNumber} alpha - shape parameter
* @param {PositiveNumber} beta - scale parameter
* @returns {(Error|null)} error or null
*
* @example
* var err = validate( 1.0, 2.0 );
* if ( err ) {
*     throw err;
* }
*/
function validate( alpha, beta ) {
	if ( !isPositive( alpha ) ) {
		return new TypeError( 'invalid argument. `alpha` must be a positive number. Value: `' + alpha + '`.' );
	}
	if ( !isPositive( beta ) ) {
		return new TypeError( 'invalid argument. `beta` must be a positive number. Value: `' + beta + '`.' );
	}
	return null;
}


// EXPORTS //
export default validate;
